import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigService, FileEntity, Image } from 'src/app/core';
import { AreYouSureComponent } from 'src/app/feature/components';
import { DocumentService } from 'src/app/shared';
import { SubSink } from 'subsink';

import { AdminUnconfirmSharedFileComponent } from '../admin-unconfirm-shared-file/admin-unconfirm-shared-file.component';

@Component({
  selector: 'app-admin-document-preview',
  templateUrl: './admin-document-preview.component.html',
  styleUrls: ['./admin-document-preview.component.sass'],
})
export class AdminDocumentPreviewComponent implements OnInit {
  public images: Image[] = [];
  private subsink = new SubSink();

  constructor(
    @Inject(MAT_DIALOG_DATA) public file: FileEntity,
    private documentsService: DocumentService,
    private configService: ConfigService,
    private dialog: MatDialog
  ) {}
  ngOnInit(): void {
    this.getImages();
  }

  public confirm() {
    this.subsink.sink = this.dialog
      .open(AreYouSureComponent)
      .afterClosed()
      .subscribe((result: boolean) => {
        if (!!result) {
          this.subsink.sink = this.documentsService
            .confirm(this.file.id)
            .subscribe((data) => {
              this.file = data;
            });
        }
      });
  }

  public unconfirm() {
    this.subsink.sink = this.dialog
      .open(AdminUnconfirmSharedFileComponent, {
        data: this.file,
        width: '400px',
      })
      .afterClosed()
      .subscribe((data: FileEntity | undefined) => {
        if (data) {
          this.file = data;
        }
      });
  }

  getBaseUrl() {
    return this.configService.getBaseUrl();
  }

  getDate() {
    return new Date(this.file.createdAt!);
  }

  getImages() {
    this.documentsService.getImagesOf(this.file.id).subscribe((data) => {
      this.images = data;
    });
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
  }
}
